module.exports = function() {
  return new Worker(__webpack_public_path__ + "c59093a97ad2458119f8.worker.js");
};